/*
 * @Author: sunxiaoshen
 * @Date: 2019-08-06
 */
import React from 'react';
import classNames from 'classnames';

import Input from '../Input';
import Button from '../Button';
import Icon from '../Icon';
import PropTypes from 'prop-types';

import { useDefault } from '../../common/hooks';

import { nfn } from '../../common';

function SearchInput({
  defaultValue = '',
  onChange,
  onSearch,
  placeholder,
  inputStyle,
  addon,
  mini,
  hasError,
  clearable,
  style,
  className,
  ...others
}) {
  const [value, setValue] = useDefault(defaultValue);

  const onValueChange = val => {
    setValue(val);
    onChange(val);
  };

  const classes = classNames('search-input', className, {
    mini
  });

  return (
    <div className={classes} style={style}>
      <Input
        defaultValue={value}
        clearable
        mini={mini}
        isSearch={mini}
        hasError={hasError}
        onChange={onValueChange}
        placeholder={placeholder}
        style={inputStyle}
        {...others}
        onKeyDown={e => {
          if (e.keyCode === 13) {
            onSearch && onSearch(value);
          }
        }}
      />
      {addon ? (
        <span onClick={() => onSearch(value)}>{addon}</span>
      ) : (
        <Button width="68" type="primary" onClick={() => onSearch(value)}>
          <Icon fill="#fff" stroke="#fff" type="search" />
        </Button>
      )}
    </div>
  );
}
SearchInput.defaultProps = {
  clearable: true,
  onChange: nfn,
  mini: false,
  onSearch: nfn
};
SearchInput.propTypes = {
  /** 默认值 */
  defaultValue: PropTypes.any,
  /** 是否是小型 */
  mini: PropTypes.bool,
  /** 是否出错 */
  hasError: PropTypes.bool,
  /** 输入框的样式 */
  inputStyle: PropTypes.object,
  /** change回调 */
  onChange: PropTypes.func,
  /** 搜索回调 */
  onSearch: PropTypes.func,
  /** 键入回调 */
  onKeyDown: PropTypes.func,
  /** 可清空 */
  clearable: PropTypes.bool,
  /** 定制搜索部件 */
  addon: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
export default React.memo(SearchInput);
